//register GLOBAL Components
import Vue from 'vue';
import Btn from '@components/Btn/Btn';
import Preloader from '@components/Preloader/Preloader';

Vue.component('btn', Btn);
Vue.component('preloader', Preloader);



